// Custom components are built where they are used (`/apps`, Apps in the rail): old links land there.
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_settings/settings/components')({
  beforeLoad: () => {
    throw redirect({ to: '/apps', replace: true });
  },
});
